// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr       : false,
    apiURL    : 'https://f2gw.dev.bizmotionapp.com/',
    mapApiKey : 'AIzaSyDm3ptJ-d3kftiMDwmJ4MxcBMGM6M3pAhA',
    socketUrl : 'ws://dev1.biz-motion.com:8080/fmcgws/notifications',
};

/*
 * In development mode, to ignore zone related error stack frames such as `zone.run`,
 * `zoneDelegate.invokeTask` for easier debugging, you can import the following file, but
 * please comment it out in production mode because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
